import qs from 'qs'

import HttpClient from 'services/HttpClient'
import { IPackagesQueryPayload } from 'types/packages'

export class PackagesRepository {
  api: typeof HttpClient

  constructor(api: typeof HttpClient) {
    this.api = api
  }

  /**
   * GET /packages – list by source (product vs landing_page) and type (package vs iframe).
   * Query: limit, order, filter[packageType], filter[source], filter[country], filter[brandName], filter[categoryId], filter[sku],
   *        filterByPart[partnerName], filterByPart[name].
   */
  getAllPackages({ query }: { query: IPackagesQueryPayload }) {
    const limit = query.limit ?? { take: 8, page: 1 }
    const order = query.order ?? { by: 'createdAt', dir: 'desc' }
    const params: Record<string, string | number> = {
      'limit[take]': limit.take ?? 8,
      'limit[page]': limit.page ?? 1,
      'order[by]': order.by ?? 'createdAt',
      'order[dir]': order.dir ?? 'desc'
    }

    if (query.filter?.packageType != null) {
      params['filter[packageType]'] = query.filter.packageType
    }

    if (query.filter?.source != null) {
      params['filter[source]'] = query.filter.source
    }

    if (query.filter?.country) {
      params['filter[country]'] = query.filter.country
    }

    if (query.filter?.brandName) {
      params['filter[brandName]'] = query.filter.brandName
    }

    if (query.filter?.categoryId) {
      params['filter[categoryId]'] = query.filter.categoryId
    }

    if (query.filter?.sku) {
      params['filter[sku]'] = query.filter.sku
    }

    if (query.filterByPart?.partnerName) {
      params['filterByPart[partnerName]'] = query.filterByPart.partnerName
    }

    if (query.filterByPart?.name) {
      params['filterByPart[name]'] = query.filterByPart.name
    }

    // Legacy: name search via search param if filterByPart.name not used
    if (!query.filterByPart?.name && query.filterByPart?.fileName) {
      params['filterByPart[name]'] = query.filterByPart.fileName
    }

    return this.api.get(`/packages?${qs.stringify(params)}`)
  }

  getPackageByPublicToken(token: string) {
    return this.api.get(`/packages/${token}`, { skipAuth: true })
  }

  deletePackages(ids: string[]) {
    return this.api.delete(`/packages?ids=${JSON.stringify(ids)}`)
  }
}

 
export default new PackagesRepository(HttpClient)
